<template>
  <HomeBanner />
  <HomeWorth />
  <HomeEngine />
  <HomeFeature />
  <HomeAbout />
  <HomeHistory />
</template>

<script lang="ts" type="text/tsx">
import AOS from 'aos';

import HomeBanner from '@template/overseas/home/homeBanner.vue';
import HomeWorth from '@template/overseas/home/homeWorth.vue';
import HomeEngine from '@template/overseas/home/homeEngine.vue';
import HomeFeature from '@template/overseas/home/homeFeature.vue';
import HomeAbout from '@template/overseas/home/homeAbout.vue';
import HomeHistory from '@template/overseas/home/homeHistory.vue';

export default {
  name: 'home',
  components: {
    HomeBanner,
    HomeWorth,
    HomeEngine,
    HomeFeature,
    HomeAbout,
    HomeHistory
  },
  mounted(): void {
    AOS.init({
      offset: 0,
      delay: 100,
      duration: 1000,
      easing: 'ease',
      once: true,
      anchorPlacement: 'top-center'
    });
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}overseas/home/';
</style>